requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data("xMultipleStores", () => ({
      active: 1,
      open: false,
      canScroll: false,
      atTop: true,
      atBottom: false,
      atEnd:false,
      showStore: false,
      load() {
        const canScrollVertically = this.$refs.list_stores.scrollHeight > this.$refs.list_stores.closest(".multi_stores_content").clientHeight;
        if (canScrollVertically) {
          this.canScroll = true;
        }
        window.addEventListener('resize', ()=> {
          this.heightNatural();
        })
        this.heightNatural();
      },
      heightNatural() {
        if (window.matchMedia("(min-width: 768px)").matches) {
          if(this.$refs.natural_height) {
             this.$refs.natural_height.style.height = this.$refs.h_img_location.offsetHeight +'px';
          }
        } else {
          if(this.$refs.natural_height) {
            this.$refs.natural_height.style.removeProperty('height');
          }
        }
      },
      openLocation(el) {
        this.open = true;
        var popupContent = document.getElementById(el.getAttribute("data-id"));
        
        this.$refs.content_location_detail.innerHTML = popupContent.innerHTML;
        const title = this.$refs.content_location_detail.querySelector('h5.location-title');
        if (title) {
          const h4 = document.createElement('h4');

          h4.innerHTML = title.innerHTML;
          h4.className = title.className;

          title.replaceWith(h4);
        }
      },
      hideLocation() {
        requestAnimationFrame(() => {
          this.open = false;
          Alpine.store('xPopup').open = false;
        });
      },
      scrollUp() {
        this.$refs.list_stores.scrollBy({
          top: -200, 
          behavior: 'auto'
        });
        this.checkCanScrollVertical()
      },
      scrollDown() {
        this.$refs.list_stores.scrollBy({
          top: 200,
          behavior: 'auto'
        });
        this.checkCanScrollVertical()
      },
      checkCanScrollVertical() {
        if (window.innerWidth < 768) {
          this.atTop = this.$refs.list_stores.scrollTop === 0;
          this.atBottom = (this.$refs.list_stores.scrollTop + this.$refs.list_stores.closest(".multi_stores_content").clientHeight) >= (this.$refs.list_stores.scrollHeight - 2);
        }
      },
      syncScrollbar() {
        const thumb = this.$refs.scrollbar_thumb;
        const isMobile = window.innerWidth < 768;
        const desktopEl = isMobile ? this.$refs.list_stores : this.$refs.list_stores.closest(".multi_stores_content");
        
        if (!thumb || !desktopEl) return;

        const scrollHeight = desktopEl.scrollHeight;
        const clientHeight = desktopEl.clientHeight;
        const maxScrollTop = scrollHeight - clientHeight;

        if (maxScrollTop <= 0) {
          thumb.style.display = 'none';
          return;
        } else {
          thumb.style.display = 'block';
        }

        const thumbHeight = Math.max((clientHeight / scrollHeight) * clientHeight, 40);
        thumb.style.height = `${thumbHeight}px`;

        const scrollPercentage = desktopEl.scrollTop / maxScrollTop;
        const maxThumbTravel = clientHeight - thumbHeight;

        let thumbY = scrollPercentage * maxThumbTravel;
        
        if (!isMobile) {
          thumbY += desktopEl.scrollTop;
        }

        thumb.style.transform = `translateY(${thumbY}px)`;
      },
      checkAtEnd() {
        const desktopEl = this.$refs.list_stores.closest(".multi_stores_content");
        const mobileEl = this.$refs.list_stores;

        if (window.innerWidth < 768) {
          this.atEnd = (mobileEl.scrollTop + desktopEl.clientHeight) >= (mobileEl.scrollHeight - 24);
        } else {
          const nearEnd = desktopEl.scrollTop + desktopEl.clientHeight >= desktopEl.scrollHeight - 32;
          
          if (nearEnd && !this.atEnd) {
            this.atEnd = true;
          }
          
          if (!nearEnd && desktopEl.scrollTop + desktopEl.clientHeight < desktopEl.scrollHeight - 40) {
            this.atEnd = false;
          }
        }
      },
      toggleStore(noScroll = false) {
        this.showStore = !this.showStore;
        if (!this.showStore) {
          this.$refs.first_store.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        if (!noScroll) {
          this.canScroll = !this.canScroll;
          this.$refs.list_stores.addEventListener("animationend", this.checkCanScrollVertical());
          setTimeout(() => {
            this.$refs.list_stores.removeEventListener("animationend", this.checkCanScrollVertical());
          }, 300);
        }
      }
    }));
  });
});